__webpack_require__.p = "https://ui-cdn.digitalocean-ui.com/federation/navigation/";